import React, { useEffect, useState } from "react";

import styles from "./styles";
// MATERIAL UI
import { withStyles } from "@mui/styles";
import { Box, Typography, Grid } from "@mui/material";
import myfuctions from "../../services/myfunctions";
import Cuadro from "../../Layout/Cuadro";
import { useUsuario } from "../../context/usuario-context";
import DialogQuestions from "./DialogQuestions";
import TimerPoint from "./TimerPoint/TimerPoint";
import LoadingButton from "@mui/lab/LoadingButton";
import { styled } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import mujer_7 from "../../assets/images/mujer_7.png";

const listPalabras = [
  {
    pos: [3, 0],
    sentido: 1,
    palabra: "ahorro",
    pista:
      "Optimización del consumo energético con el objetivo final de disminuir el uso de energía.",
  },
  {
    pos: [2, 5],
    sentido: 0,
    palabra: "foco",
    pista:
      "¡Mi amor! prendelo solo cuando sea necesario, hazme caso y evítate un calvario.",
  },
  {
    pos: [4, 5],
    sentido: 1,
    palabra: "calor",
    pista: "¿Cuando hay altas temperaturas tu dices que tienes?",
  },
  {
    pos: [1, 9],
    sentido: 0,
    palabra: "energia",
    pista: "Capacidad de hacer funcionar las cosas.",
  },
  {
    pos: [7, 5],
    sentido: 1,
    palabra: "contador",
    pista: "Se utiliza para el registro del consumo de energía.",
  },
  {
    pos: [0, 11],
    sentido: 0,
    palabra: "televisor",
    pista: "Aparato eléctrico que recibe y reproduce imágenes y sonidos.",
  },
];

let audioUno = new Audio(
  "https://firebasestorage.googleapis.com/v0/b/energygrama.appspot.com/o/audios%2Fbotones.mp4?alt=media&token=842990aa-3897-43de-a42d-5978db162bc0"
);

let playUno = () => {
  audioUno.play();
};

let audioDos = new Audio(
  "https://firebasestorage.googleapis.com/v0/b/energygrama.appspot.com/o/audios%2Fcorrecto.mpeg?alt=media&token=ce31df8d-612f-46db-a4df-638dddfe97ad"
);

let playDos = () => {
  audioDos.play();
};

let audioTres = new Audio(
  "https://firebasestorage.googleapis.com/v0/b/energygrama.appspot.com/o/audios%2Fpopup.mp4?alt=media&token=fe8c4d8f-5c83-4ea1-bc5a-68b3943965e5"
);

let playTres = () => {
  audioTres.play();
};

const CerrarButton = styled(LoadingButton)(({ theme }) => ({
  color: theme.palette.getContrastText("#000"),
  backgroundColor: "#1a5080",
  "&:hover": {
    backgroundColor: "#85a537",
  },
  width: "100px",
  height: "36px",
  fontWeight: "bold",
  fontSize: "12px",
  borderRadius: "20px",
  lineHeight: 1.2,
  boxShadow:
    "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)",
}));

function CrucigramaGame(props) {
  let { classes } = props;
  let history = useHistory();
  const { dataUser } = useUsuario();
  const [error, setError] = useState(false);
  const [palabras, setPalabras] = useState([]);
  const [completed, setCompleted] = useState(
    Array(listPalabras.length).fill(false)
  );
  const [selected, setSelected] = useState(undefined);
  const [answer, setAnswer] = useState("");
  const [matrix, setMatrix] = useState([]);
  const [openQuestion, setOpenQuestion] = useState(false);
  const [timer, setTimer] = useState(240);
  const [finish, setFinish] = useState(dataUser.crossword);

  useEffect(() => {
    setPalabras(listPalabras);
    created();

    let timer = null;
    const timecuno = localStorage.getItem("timecuno");
    if (timecuno === null) {
      timer = 240;
      localStorage.setItem("timecuno", timer);
      setTimer(timer);
    } else {
      if (parseInt(timecuno) > 240) {
        timer = 240;
        setTimer(timer);
      } else {
        timer = timecuno;
        setTimer(timer);
      }
    }
  }, []);

  let created = () => {
    // Arreglo de palabras indicando la posición de su inicio, su sentido (vertical u horizontal),
    // la palabra en cuestión y la pista que se presenta al usuario
    const palabras = listPalabras;

    // Objeto default para celdas vacías de la grilla
    const empty = {
      start: false,
      letter: "",
      words: [],
      empty: true,
    };
    // Creación de la tabla que contiene las celdas.
    const width = palabras.reduce(
      (max, cur) =>
        Math.max(
          max,
          cur.pos[0] + (cur.sentido === 0 ? cur.palabra.length : 1)
        ),
      0
    );
    const height = palabras.reduce(
      (max, cur) =>
        Math.max(
          max,
          cur.pos[1] + (cur.sentido === 1 ? cur.palabra.length : 1)
        ),
      0
    );
    let matrix = Array(height)
      .fill(0)
      .map(() =>
        Array(width)
          .fill(null)
          .map(() => empty)
      );
    palabras.forEach((palabra, index) => {
      const [x, y] = palabra.pos;
      palabra.palabra.split("").forEach((l, i) => {
        let cell =
          matrix[y + (palabra.sentido ? i : 0)][x + (palabra.sentido ? 0 : i)];
        if (cell === empty) {
          cell = matrix[y + (palabra.sentido ? i : 0)][
            x + (palabra.sentido ? 0 : i)
          ] = { words: [] };
        }
        cell.empty = false;
        cell.words.push(index);
        if (i === 0) {
          cell.start = index + 1;
        }
        cell.letter = l;
      });
    });
    setMatrix(matrix);
  };

  let selectWord = (index) => {
    if (index > 0) {
      playUno();
      setSelected(index - 1);
      setAnswer("");
      setOpenQuestion(true);
    }
  };

  let solution = (value) => {
    const solution = palabras[selected].palabra;
    setAnswer(value);
    const answer = value.toLowerCase();
    if (answer === solution) {
      completed[selected] = true;
      setSelected(undefined);
      setCompleted(completed);
      setAnswer("");
      setOpenQuestion(false);

      const result = completed.filter((complete) => complete);

      if (result.length === completed.length) {
        playTres();
        updateFinished(
          "Acabas de superar el primer nivel de este Energy-Grama. Continua ganando para llegar al los Top 100"
        );
      } else {
        playDos();
      }
    }
  };

  let updateTimer = () => {
    localStorage.setItem("timecuno", timer - 1);
    setTimer(timer - 1);
  };

  let updateFinished = async () => {
    try {
      setFinish(true);
      const crucigrama_puntos = points();
      await myfuctions
        .updateCrucigrama(dataUser.userId, crucigrama_puntos)
        .then((result) => {})
        .catch((error) => {
          console.log(error);
          setError(true);
        });
    } catch (error) {
      console.log(error);
      setError(true);
    }
  };

  let points = () => {
    const result = completed.filter((complete) => complete);
    return result.length * 100 + timer;
  };

  let handleCloseDialog = () => {
    setOpenQuestion(false);
  };

  if (error) {
    return " Ha ocurrido un error";
  }

  if (finish) {
    return (
      <Cuadro bgCuadro="#fff">
        <Grid container>
          <Grid item xs={12} className="cCongratulations">
            <Typography
              variant="h3"
              className="congratulations"
              align="justify"
            >
              ¡FELICITACIONES!
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <div className="puntosImgC">
              <Typography
                variant="subtitule1"
                className="ctextPuntos"
                align="center"
              >
                Completaste<br></br>
                el polograma<br></br>
                exitosamente
                <br></br>
                <br></br>
                <CerrarButton
                  variant="contained"
                  loadingPosition="start"
                  style={{ marginTop: "10px" }}
                  onClick={() => history.push("/")}
                >
                  Cerrar
                </CerrarButton>
              </Typography>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <div className="divNino">
              <img src={mujer_7} alt="Chica" className="chicaPlanchaImg" />
            </div>
          </Grid>
        </Grid>
      </Cuadro>
    );
  }
  return (
    <>
      <Cuadro bgCuadro="#011956">
        <TimerPoint
          points={points}
          updateTimer={updateTimer}
          updateFinished={updateFinished}
          completed={completed}
          timer={timer}
        />
        <Box display="flex" justifyContent="center">
          {matrix.length > 0 ? (
            <div className={classes.tableContent}>
              <table border="1" className={classes.table}>
                <tbody>
                  {matrix.map((row, y) => {
                    return (
                      <tr key={y}>
                        {row.map((cell, x) => {
                          let tdClassName = classes.td;
                          if (cell.empty) {
                            tdClassName += ` ${classes.empty}`;
                          }
                          if (cell.start) {
                            tdClassName += ` ${classes.start}`;
                          }
                          if (cell.words.includes(selected)) {
                            tdClassName += ` ${classes.selected}`;
                          }

                          return (
                            <td
                              key={x}
                              className={tdClassName}
                              onClick={() => selectWord(cell.start)}
                            >
                              {cell.words.some((i) => completed[i])
                                ? cell.letter
                                : cell.start
                                ? cell.letter
                                : ""}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            "Cargando"
          )}
        </Box>
      </Cuadro>
      <DialogQuestions
        solution={solution}
        handleCloseDialog={handleCloseDialog}
        palabras={listPalabras}
        selected={selected}
        answer={answer}
        open={openQuestion}
      />
    </>
  );
}

export default withStyles(styles)(CrucigramaGame);
